import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import type { ComponentProps } from "react";
import { createElement } from "react";
import { z } from "zod";

import { defineHead } from "../-common";

import { usePageSearchSetters } from "./-common";

import { OrdersPage } from "~/pages/admin-panel";
import { Tk } from "~/shared/i18n";
import { zPageSearch } from "~/widgets/admin-panel/model/page-search";

const zOrdersPageActionType = z.enum(["VIEW", "DELETE"]);

function Component() {
  const navigate = useNavigate({
    from: Route.fullPath,
  });
  const { filter, currentAction } = Route.useSearch();

  return createElement(OrdersPage, {
    search: {
      filter,
      currentAction,
      ...usePageSearchSetters(navigate, filter, currentAction),
    },
  } satisfies ComponentProps<typeof OrdersPage>);
}

export const Route = createFileRoute("/{-$locale}/admin-panel/orders")({
  head: defineHead({
    titleT: {
      key: Tk.ORDER,
      options: {
        count: 2,
      },
    },
  }),
  component: Component,
  validateSearch: zodValidator(zPageSearch(zOrdersPageActionType)),
});
